// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
import router from "./router";
Vue.use(ElementUI);
Vue.config.productionTip = false;

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

function contains(arr, obj) {
  var i = arr.length;
  //判断元素是否存在
  while (i--) {
    if (arr[i] === obj) {
      return true; //若存在返回true
    }
  }
  return false; //若不存在返回false
}
var language = (navigator.language || navigator.browserLanguage).toLowerCase();
console.log("语言", language);
var lan = language.substr(0, 2);
var arr = ["zh", "en", "ja", "ko"]; //定义一个语言数组
if (contains(arr, lan)) {
  //判断lan是否在数组内
  if (language.substr(0, 2).indexOf("zh") == -1) {
    //非中文
    language = lan;
  } else {
    if (language == "zh-tw") {
      language = "zh-TW";
    } else {
      language = "zh-CN";
    }
  }
} else {
  language = "en";
}

const i18n = new VueI18n({
  locale: language, // 语言标识
  messages: {
    "zh-CN": require("./assets/lang/zh-CN"),
    "zh-TW": require("./assets/lang/zh-TW"),
    en: require("./assets/lang/en"),
    ja: require("./assets/lang/ja"),
    ko: require("./assets/lang/ko")
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js